/*
 *
 * TestResults constants
 *
 */

export const SLICE_NAME = 'testResults';
